exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".email-configurations-wrapper .email-configurations-card{border:none}", ""]);
